import * as React from 'react';

import Button from '../../atoms/button';
import { CloseCross } from '../../atoms/icons';

const ModalCloseButton = ({
  size,
  variant,
  type,
  shape,
  fill,
  width,
  height,
  onClick,
  customClasses,
}) => {
  return (
    <Button
      customClasses={customClasses}
      size={size}
      variant={variant}
      as={type}
      shape={shape}
      fill={fill}
      onClick={onClick}
    >
      <CloseCross
        className={customClasses?.icon}
        width={width}
        height={height}
      />
    </Button>
  );
};

export default ModalCloseButton;
